import { IConversationUnreadCount } from "@/interfaces/iMessage";
import { IOptionModel } from "@/interfaces/iPageModel";
import { ApiService } from "./AbstractApiService";
import API from "./handlers/base.service";
export class NotificationApi extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: NotificationApi | null;
  constructor() {
    super("notification");
  }
  public async getSMSCount(): Promise<number> {
    return this.get("readSmsCount").then((response) => response.data);
  }
  public async getEmailCount(): Promise<number> {
    return this.get("readEmailCount").then((response) => response.data);
  }
  public async getGraphQlInfo(): Promise<Array<IOptionModel>> {
    return this.get("key/graphql").then((response) => response.data);
  }
  public async unReadSmsCount(): Promise<number> {
    return this.get("unReadSmsCount").then((response) => response.data);
  }
  public async unReadEmailCount(): Promise<number> {
    return this.get("unReadEmailCount").then((response) => response.data);
  }
  //conversationUnreadCount
  public async conversationUnreadCount(): Promise<IConversationUnreadCount[]> {
    return this.get("conversationUnreadCount").then((res) => res.data);
  }
}
